import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as RecordIcon } from "../icons/recording.svg";
import styles from "./AudioRecordingAI.scss";
import { LiveAudioVisualizer } from "react-audio-visualize";
import { Spinner } from "@fluentui/react-components";

import { DismissCircle20Filled, CheckmarkCircle20Filled } from "@fluentui/react-icons";
import { useMicrophoneStatus } from "./useMicrophoneStatus";
import { PermissionStatus } from "../../utils/media-devices-utils";
// import { useVoskMicrophone } from "./hooks/vosk/useMicrophoneVosk";
import aiAgents from "../../singleton/AIAgents";

export function AudioRecorder({ recording, setRecording, receiver, scene, mySessionId, setMessage }) {
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const intervalIdRef = useRef(null);
  const receiverRef = useRef(null);
  const recordingCanceledRef = useRef(false);

  // const [outerCircleSize, setOuterCircleSize] = useState(64);
  // const [middleCircleSize, setMiddleCircleSize] = useState(60);
  const [timer, setTimer] = useState(0);
  const [recordingCanceled, setRecordingCanceled] = useState(false);
  const [loadingTranscript, setLoadingTranscript] = useState(false);

  const selectedMic = window.APP.mediaDevicesManager.selectedMicDeviceId;

  const { permissionStatus } = useMicrophoneStatus(scene);
  const micPermissionDenied = permissionStatus === PermissionStatus.DENIED;
  // const {setMuted: setVoskMuted, startRecognitionStream, utterances, recognizer, setUtterances} = useVoskMicrophone();
  // const utterancesRef = useRef(utterances);
  // const recognizerRef = useRef(recognizer);
  // useEffect(() => {
  //   recognizerRef.current = recognizer;
  // }, [recognizer])

  // useEffect(() => {
  //   utterancesRef.current = utterances;
  // }, [utterances])

  useEffect(() => {
    recordingCanceledRef.current = recordingCanceled;
  }, [recordingCanceled]);

  const handleStop = async () => {
    if (recordingCanceledRef.current) {
      // Reset the ref for the next recording
      recordingCanceledRef.current = false;
      setRecording(false);
      setLoadingTranscript(false);
      return;
    }

    // voskManager.captureMic = false;

    // Wait for the recognizer to dispatch the final result or timeout
    // const waitForRecognizerResult = new Promise((resolve) => {
    //   const timeout = setTimeout(() => {
    //     console.warn("Recognizer did not dispatch result in time.");
    //     resolve(null);
    //   }, 3000); // Adjust timeout duration as needed

    //   const handleResult = (message) => {
    //     if (message.result) {
    //       // setUtterances([...utterancesRef.current, message.result]);
    //       clearTimeout(timeout);
    //       resolve(message.result.text);
    //     }
    //   };

    //   recognizerRef.current.addEventListener("result-text", handleResult);
    //   let result = recognizerRef.current.retrieveFinalResult();
    // });

    // const finalTranscript = await waitForRecognizerResult;

    // const copyUtterances = JSON.parse(JSON.stringify(utterancesRef.current));
    // const promptTranscribed = voskManager.getPromptCleaned(copyUtterances);

    // voskManager.recognizer.setWords(false);

    // const promptTranscribed = await finalizeRecognition(recognizerRef.current, utterancesRef.current);

    const agent = aiAgents.getAgentById(receiverRef.current);
    // Pass agent.objectUuid instead of agent.apiKey
    const promptTranscribed = await aiAgents.getOpenAITranscriptionByAudio(
      audioChunksRef.current,
      false,
      agent.objectUuid
    );

    if (!promptTranscribed) {
      setRecording(false);
      setLoadingTranscript(false);
      setMessage("");
      return;
    }

    setMessage(promptTranscribed);
    setRecording(false);
    setLoadingTranscript(false);
  };

  useEffect(() => {
    receiverRef.current = receiver;
  }, [receiver]);

  useEffect(() => {
    // Request permissions and set up the MediaRecorder
    const getMedia = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId: selectedMic
          }
        });

        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = audioContext.createAnalyser();
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        audioContextRef.current = audioContext;
        analyserRef.current = analyser;

        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorderRef.current = mediaRecorder;

        mediaRecorder.ondataavailable = event => {
          if (event.data.size > 0) {
            audioChunksRef.current.push(event.data);
          }
        };

        mediaRecorder.onstop = handleStop;
      } catch (error) {
        console.error("Error accessing media devices.", error);
      }
    };
    if (!micPermissionDenied) {
      getMedia().catch(error => console.error(error));
    }
  }, [micPermissionDenied]);

  // const update = useCallback(
  //   level => {
  //     if (!recording) return;
  //     let outerSize = Math.min(80, 56 + level * 40);
  //     let middleSize = Math.min(68, 56 + level * 20);

  //     setOuterCircleSize(outerSize);
  //     setMiddleCircleSize(middleSize);
  //   },
  //   [recording, setOuterCircleSize, setMiddleCircleSize]
  // );

  // useVolumeMeter({
  //   analyser: scene.systems["hubs-systems"].audioSystem.outboundAnalyser,
  //   update
  // });

  useEffect(() => {
    if (recording) {
      // startRecognitionStream();
      // setVoskMuted(false);
      audioChunksRef.current = [];
      mediaRecorderRef.current.start();
      setTimer(0);

      // voskManager.captureMic = true;

      intervalIdRef.current = setInterval(() => {
        setTimer(prev => prev + 1); // Increment timer by 1 second
      }, 1000);
    } else if (recording && !mediaRecorderRef.current) {
      alert("Error accessing media devices, please check your microphone permissions.");
      stopRecording();

      clearInterval(intervalIdRef.current);
      // setVoskMuted(true);
    } else {
      // setVoskMuted(true);
    }
  }, [recording]);

  const stopRecording = () => {
    //1. Set Loading
    setLoadingTranscript(true);
    clearInterval(intervalIdRef.current);
    //2. Stop media recorder
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }

    //3. Send transcript

    //4. Stop recording to switch to text mode
  };

  const startRecording = () => {
    setRecording(true);
  };

  const cancelRecording = () => {
    recordingCanceledRef.current = true;
    mediaRecorderRef.current.stop();
  };

  const formattedTime = `${String(Math.floor(timer / 60)).padStart(2, "0")}:${String(timer % 60).padStart(2, "0")}`;

  if (!recording) return <></>;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        gap: "10px",
        backgroundColor: "rgba(245, 245, 245, 0.1)",
        paddingLeft: "10px",
        paddingRight: "10px",
        display: "flex",
        alignItems: "center",
        borderRadius: "4px"
      }}
    >
      {mediaRecorderRef.current && recording && (
        <>
          <DismissCircle20Filled style={{ cursor: "pointer" }} onClick={cancelRecording} />
          <div style={{ display: "flex", gap: "10px", width: "227px", padding: "5px 2px 7px 2px" }}>
            <LiveAudioVisualizer
              mediaRecorder={mediaRecorderRef.current}
              barWidth={3}
              barColor={"#fff"}
              width={200}
              height={18}
              smoothingTimeConstant={0}
              maxDecibels={-50}
              gap={2}
              fftSize={256}
            />
            <div>{formattedTime}</div>
          </div>
          {!loadingTranscript && (
            <CheckmarkCircle20Filled style={{ cursor: "pointer", marginLeft: "auto" }} onClick={stopRecording} />
          )}
          {loadingTranscript && <Spinner size="tiny" style={{ marginLeft: "auto" }} />}
        </>
      )}
    </div>
  );
}

export function RecordButtonInput({ recording, setRecording }) {
  return (
    <div className={styles.recordButton} onClick={recording ? () => setRecording(false) : () => setRecording(true)}>
      <RecordIcon />
    </div>
  );
}
